import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import gold from "../../../../../assets/icons/asset-icons/gold.svg";
import Button from "../../../../common/Button/Button";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Pagination from "../../../../common/Pagination/Pagination";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import TransactionTypeBadge from "../TransactionTypeBadge/TransactionTypeBadge";
import styles from "../Transactions.module.scss";
import { getType } from "../Transactions";
import OrderDetailsCompleted from "../../../../common/Modals/OrderDetailsCompleted/OrderDetailsCompleted";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { getTransactionsAction } from "../../../../../features/user/userSlice";
import { formatPrice, toFix } from "../../../../../utils/utils";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { useDebounce } from "../../../../customHook/useDebeunce";

const CompletedTransactions = () => {
  const dispatch = useDispatch();
  const search = useOutletContext();
  const [transactions, setTransactions] = useState({});
  const [orderId, setOrderId] = useState({ orderId: "", transactionId: "" });
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const [activeSortColumn, setActiveSortColumn] = useState(null);
  const debounced = useDebounce(search, 500);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const fields = [
    { label: "Order ID" },
    { label: "Asset" },
    { label: "Type" },
    { label: "Qty", sort: true },
    { label: "Price", sort: true },
    { label: "Total" },
    { label: "Created From" },
    { label: "Date", sort: true },
    { label: "Status" },
    { label: "Actions" },
  ];

  const getTransactions = async () => {
    setLoading(true);
    try {
      const params = {
        page: page,
        size: pageSize,
        filterByStatus: "COMPLETED",
      };
      if (debounced) {
        params.searchKeyword = debounced;
      }
      if (activeSortColumn === "Qty") {
        params.sortByQuantity = quantityOrder === true ? "ASC" : "DESC";
      }
      if (activeSortColumn === "Date") {
        params.sortByDate = dateFilter === true ? "ASC" : "DESC";
      }
      if (activeSortColumn === "Price") {
        params.sortByPrice = priceOrder === true ? "ASC" : "DESC";
      }

      const response = await dispatch(getTransactionsAction(params));
      if (response.status === 200) {
    
        setTransactions(response.data.data.data);
        setTotalPages(response?.data?.data?.totalPages);
        setImageURL(response.data.data.imageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getStatus = (status) => {
    if (status === "completed" || status === "delivered") {
      return styles.green;
    } else if (status === "cancelled") {
      return styles.red;
    } else {
      return "";
    }
  };

  const openDetailModal = (orderId, transactionId) => {
    setOrderId({ orderId, transactionId });
    setShow(true);
  };

  const callBackOnClick = (data) => {
    setPage(1);
    if (data === "Qty") {
      setQuantityOrder((prev) => !prev);
      setActiveSortColumn("Qty");
    }
    if (data === "Price") {
      setPriceOrder((prev) => !prev);
      setActiveSortColumn("Price");
    }
    if (data === "Date") {
      setDateFilter((prev) => !prev);
      setActiveSortColumn("Date");
    }
  };
  useEffect(() => {
    getTransactions();
  }, [page, debounced, activeSortColumn, quantityOrder, priceOrder, dateFilter]);

  return (
    <>
      <Table
        noRecordContent={"No records for your search were found."}
        fields={fields}
        className={styles.table}
        loading={loading}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        onClick={callBackOnClick}
        loadingClassName={"loading_table"}
      >
        {transactions?.length > 0 &&
          transactions?.map((item, index) => (
            <tr key={index}>
              <td>
                <Tooltip
                  icon={<span>{item?.order_id}</span>}
                  content={
                    <>
                      <CopyBtn text={item?.order_id} /> {item?.order_id}
                    </>
                  }
                  className={styles.order_id}
                />
              </td>
              <td className={styles.asset}>
                <img
                  src={`${imageURL}${item?.master_tokens_configuration?.image}`}
                  alt={item?.master_tokens_configuration?.name}
                />
                {item.master_tokens_configuration?.name}
              </td>
              <td>
                <TransactionTypeBadge type={getType(item.type)}>
                  {item?.type}
                </TransactionTypeBadge>
              </td>
              <td>
                {(
                  toFix(
                    Number(item?.quantity),
                    decimalLimit[item.master_tokens_configuration?.name]
                  )
                )}
              </td>
              {/* <td>${formatPrice(Number(item?.price))}</td>
              <td>${formatPrice(Number(item?.price * item?.quantity))}</td> */}
              <td> {item?.type === "REWARD"  ? item?.price != null    ? `$${formatPrice(Number(item.price))}` : "N/A" : `$${formatPrice(Number(item?.price))}`}</td>
              <td>{item?.type === "REWARD"  ? item?.price != null && item?.quantity != null    ? `$${formatPrice(Number(item.price) * Number(item.quantity))}`    : "N/A" : `$${formatPrice(Number(item?.price) * Number(item?.quantity))}`}</td>

              <td>{item?.order_created_from}</td>
              <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
              <td
                className={`${styles.status}  ${getStatus(
                  item?.status
                )} text-capitalize`}
              >
                {item?.status?.toLowerCase()}
              </td>
              <td>
                <Button
                  variant="text_blue"
                  onClick={() => openDetailModal(item?.order_id, item?.id)}
                  className={styles.detail_btn}
                >
                  View Details
                </Button>
              </td>
            </tr>
          ))}
      </Table>
      {/* {transactions?.length > 0 && <Pagination pageCount={3} />} */}
      {totalPages > 1 && (
        <Commonpagination
          // className={classpagonation}
          currentPage={page}
          totalPages={totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <OrderDetailsCompleted
        show={show}
        handleClose={() => setShow(false)}
        orderId={orderId}
      />
    </>
  );
};

export default CompletedTransactions;
